import { render, staticRenderFns } from "./CustomerGroupSendList.vue?vue&type=template&id=19e98d8f&scoped=true&"
import script from "./CustomerGroupSendList.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupSendList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGroupSendList.vue?vue&type=style&index=0&id=19e98d8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e98d8f",
  null
  
)

export default component.exports